import { makeStyles } from "@material-ui/core/styles";

const MakeStyleModule = makeStyles((theme) => ({
  root: {
    margin: "1rem auto 0",
    marginBottom: "30px",
    background: "white",
    boxShadow: "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)",
    width: "60%",
    top: "1rem",
    padding: "2rem",
    borderRadius: "20px",
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .color-picker": {
      zIndex: "1",
      "& .MuiInputBase-root": {
        color: "#000 !important",
      },
    },
    "& .bottom-button": {
      marginRight: "5px",
    },
    "& .formcontrol-select": {
      width: "100%",
    },
    "& .GridHelperTextField": {
      margin: "10px 0 -15px 0",
    },
    "& .GridSelectRegisterInput .MuiFormControlLabel-root": {
      width: "25%",
      [theme.breakpoints.down("md")]: {
        width: "33%",
      },
    },
    "& .LabelSwitchChallenge": {
      marginBottom: "30px",
    },
    "& .GridSelectChallenge": {
      [theme.breakpoints.down("md")]: {
        // marginTop: "30px"
      },
    },
    "& .InputButton": {
      display: "none",
    },
    "& .UploadGpxButton": {
      display: "flex",
      alignItems: "center",
    },
    "& .CircleColor": {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
    },
    "& .dropzoneArea": {
      minHeight: "150px",
    },
    "& .MuiChip-label": {
      maxWidth: 200,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    "& .MuiSvgIcon-root": {
      cursor: "pointer",
    },
    "& .MuiDropzonePreviewList-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& .MuiDropzoneArea-icon": {
      width: "30px",
      height: "30px",
    },
    "& .MuiInputLabel-animated": {
      color: "black",
    },
    "& .MuiChipInput-inputRoot-249": {
      color: "black",
    },
    "& .dropzoneArea": {
      minHeight: "0",
      "& .MuiDropzoneArea-textContainer": {
        height: "40px",
        width: "100%",
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
      },
    },
    "& .GridSwitchTimeLimit": {
      paddingBottom: 0,
    },
  },
}));

export default MakeStyleModule;
